/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Tag,
    TagFromJSON,
    TagFromJSONTyped,
    TagToJSON,
} from './';

/**
 * 
 * @export
 * @interface TagDataFrame
 */
export interface TagDataFrame {
    /**
     * 
     * @type {number}
     * @memberof TagDataFrame
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof TagDataFrame
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof TagDataFrame
     */
    limit: number;
    /**
     * 
     * @type {Array<Tag>}
     * @memberof TagDataFrame
     */
    data: Array<Tag>;
}

export function TagDataFrameFromJSON(json: any): TagDataFrame {
    return TagDataFrameFromJSONTyped(json, false);
}

export function TagDataFrameFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagDataFrame {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'offset': json['offset'],
        'limit': json['limit'],
        'data': ((json['data'] as Array<any>).map(TagFromJSON)),
    };
}

export function TagDataFrameToJSON(value?: TagDataFrame | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'offset': value.offset,
        'limit': value.limit,
        'data': ((value.data as Array<any>).map(TagToJSON)),
    };
}


